<!-- Backdrop (solo mobile quando sidebar è aperta) -->
<div class="backdrop"
     [class.visible]="sidebarService.isOpen()"
     (click)="closeSidebar()"></div>

<!-- Sidebar -->
<div class="sidebar" [class.open]="sidebarService.isOpen()">
  <!-- Logo in alto -->
  <div class="sidebar-header">
    <a
      class="logo-link"
      routerLink="/dashboard"
      routerLinkActive="active"
    >
      <img
        [src]="logoPath()"
        alt="Logo"
        class="logo"
      />
    </a>
  </div>

  <!-- Menu -->
  <mat-nav-list>
    <a mat-list-item routerLink="/dashboard" routerLinkActive="active">
      <mat-icon fontSet="material-icons-outlined">dashboard</mat-icon>
      <span>Dashboard</span>
    </a>
    <a mat-list-item routerLink="/preventivi" routerLinkActive="active" *ngIf="authService.isAdmin()">
      <mat-icon fontSet="material-icons-outlined">list_alt</mat-icon>
      <span>Preventivi / Computi</span>
    </a>
    <a mat-list-item routerLink="/cantieri" routerLinkActive="active" *ngIf="authService.isAdmin()">
      <mat-icon fontSet="material-icons-outlined">apartment</mat-icon>
      <span>Cantieri</span>
    </a>
    <a mat-list-item routerLink="/fatture" routerLinkActive="active" *ngIf="authService.isAdmin()">
      <mat-icon fontSet="material-icons-outlined">receipt_long</mat-icon>
      <span>Fatture</span>
    </a>
    <a mat-list-item routerLink="/attrezzature" routerLinkActive="active">
      <mat-icon fontSet="material-icons-outlined">handyman</mat-icon>
      <span>Attrezzature</span>
    </a>
    <a mat-list-item routerLink="/garage" routerLinkActive="active">
      <mat-icon fontSet="material-icons-outlined">car_repair</mat-icon>
      <span>Garage</span>
    </a>
    <a mat-list-item routerLink="/anagrafiche" routerLinkActive="active" >
      <mat-icon fontSet="material-icons-outlined">article</mat-icon>
      <span>Anagrafiche</span>
    </a>
    <a mat-list-item routerLink="/impostazioni" routerLinkActive="active" *ngIf="authService.isAdmin()">
      <mat-icon fontSet="material-icons-outlined">settings</mat-icon>
      <span>Impostazioni</span>
    </a>
    <a mat-list-item routerLink="/costi-fissi" routerLinkActive="active"  *ngIf="authService.isAdmin()">
      <mat-icon fontSet="material-icons-outlined">payments</mat-icon>
      <span>Costi Fissi</span>
    </a>
  </mat-nav-list>

  <div class="sidebar-header" *ngIf="tenant !== 'esse3'">
    <a
      class="logo-link"
      href="https://www.primocantiere.it/"
      target="_blank"
    >
      <img
        src="assets/images/logoPrimoCantiere.png"
        alt="Primo Cantiere"
        class="logo"
      />
    </a>

    <div class="powered-by">
      <span>App realizzata da</span>

      <a
        href="https://www.swdgroup.it"
        target="_blank"
        rel="noopener noreferrer"
      >
        SWD Group srl
      </a>
    </div>
  </div>

</div>
